export default {
  sm: `
    각 세종은 서버실의 온도를 낮추는 데에 자연 바람을
    활용합니다. 금강을 통해 불어오는 차가운 북서풍을
    이용하여 냉방 효율을 높이는 등 친환경 데이터센터를
    운영하기에 좋은 입지에 위치하고 있습니다.
  `,
  lg: `
    각 세종은 서버실의 온도를 낮추는 데에 자연 바람을 활용합니다. 
    금강을 통해 불어오는 차가운 북서풍을 이용하여 냉방 효율을 높이는 등
    친환경 데이터센터를 운영하기에 좋은 입지에 위치하고 있습니다.
  `,
  xl: `
    각 세종은 서버실의 온도를 낮추는 데에 자연 바람을 활용합니다. 
    금강을 통해 불어오는 차가운 북서풍을 이용하여 
    냉방 효율을 높이는 등 친환경 데이터센터를 운영하기에
    좋은 입지에 위치하고 있습니다.
  `
};
